export default __webpack_public_path__ + "static/media/SDG7.44e65662.png";